<div [class]="notification.type.toLowerCase()"
     role="alert"
     *ngFor="let notification of notifications">
    <span [innerText]="notification?.message | translate"></span>
    <button type="button"
            class="btn-close btn-close-white"
            data-dismiss="alert"
            (click)="dismiss(notification)">
    </button>
</div>
